import MySelect from '@/components/selectHtml';
import { CommmonGet } from '@/util/network/api';
import { Form } from 'antd';
import React, { useEffect, useState } from 'react';
import './index.scss';
import { LgInput } from 'lancoo-web-ui';

interface Option {
  label: string;
  value: any;
}

interface SelectAddressProps {
  value?: string;
  onChange?: (value: string) => void;
  required: boolean;
  serveInit?: boolean;
}

const SelectAddress: React.FC<SelectAddressProps> = ({
  value,
  onChange,
  required,
  serveInit = true
}) => {
  const [province, setProvince] = useState<any>(null);
  const [city, setCity] = useState<any>(null);
  const [county, setCounty] = useState<any>(null);
  const [street, setStreet] = useState<any>(null);

  const [provincialList, setProvincialList] = useState<Option[]>([]);
  const [cityList, setCityList] = useState<Option[]>([]);
  const [countyList, setCountyList] = useState<Option[]>([]);
  const [streetList, setStreetList] = useState<Option[]>([]);

  const [errAddress, setErrAddress] = useState<string>('');
  const [provinceLabel, setProvinceLabel] = useState<string>('');
  const [cityLabel, setCityLabel] = useState<string>('');
  const [countyLabel, setCountyLabel] = useState<string>('');
  const [streetLabel, setStreetLabel] = useState<string>('');

  const [addressInfo, setAddressInfo] = useState<string>('');
  const [addSelectId, setAddSelectId] = useState<string>('');

  useEffect(() => {
    serveInit && getArrList(setProvincialList);
  }, []);

  function getArrList(setArrNmae: any, id?: any) {
    CommmonGet('/area', { id }).then((res: any) => {
      setArrNmae(res?.data || []);
    });
  }

  const handleProvinceChange = async (value: string) => {
    if (province === value) {
      return;
    }
    setCity(null);
    setCounty(null);
    setStreet(null);
    setProvince(value || null);
    setAddSelectId(value || '');
    setCityList(value ? await getArrListAsync(value) : []);
    setCountyList([]);
    setStreetList([]);
  };

  const handleCityChange = async (value: string) => {
    if (city === value) {
      return;
    }
    setCounty(null);
    setStreet(null);
    setCity(value || null);
    setAddSelectId(value || null);
    setCountyList(value ? await getArrListAsync(value) : []);
    setStreetList([]);
  };

  const handleCountyChange = async (value: string) => {
    setStreet(null);
    setCounty(value || null);
    setAddSelectId(value || null);
    setStreetList(value ? await getArrListAsync(value) : []);
  };

  const handleStreetChange = async (value: string) => {
    setStreet(value || null);
    setAddSelectId(value || '');
  };

  async function getArrListAsync(id: string): Promise<Option[]> {
    const res: any = await CommmonGet('/area', { id });
    return res?.data as Option[];
  }

  async function initArrList(value) {
    setProvince(value.slice(0, 2));
    (!cityList || cityList?.length == 0) &&
      value.length >= 2 &&
      setCityList(await getArrListAsync(value.slice(0, 2)));
    (!countyList || countyList?.length == 0) &&
      value.length >= 4 &&
      setCountyList(await getArrListAsync(value.slice(0, 4)));
    (!streetList || streetList?.length == 0) &&
      value.length >= 6 &&
      setStreetList(await getArrListAsync(value.slice(0, 6)));
    value.length >= 4 && setCity(value.slice(0, 4));
    value.length >= 6 && setCounty(value.slice(0, 6));
    value.length >= 8 && setStreet(value);
    setAddSelectId(value);
  }

  useEffect(() => {
    if (
      value?.split('~')?.length > 1 &&
      value?.split('~')?.[0]?.length >= 2 &&
      (!province || !city || !county || !street)
    ) {
      initArrList(value.split('~')[0]);
    } else if (value?.split('~')?.length === 1) {
      setErrAddress(value);
    }
    if (value && value?.split('~')?.length > 1 && splitStringByDelimiter(value, '~') && !addressInfo) {
      setAddressInfo(splitStringByDelimiter(value, '~'));
    }
  }, [value]);
  function splitStringByDelimiter(
    str: string,
    delimiter: any,
    partIndex: number = 3
  ) {
    const parts = str.split(delimiter);

    let result: string = '';
    if (parts.length >= partIndex) {
      result = parts.slice(partIndex - 1).join(delimiter);
    } else {
      result = '';
    }

    return result;
  }

  useEffect(() => {
    onChange?.(
      (addSelectId || '') +
      '~' +
      (provinceLabel || '') +
      (cityLabel || '') +
      (countyLabel || '') +
      (streetLabel || '') +
      '~' +
      (addressInfo || '')
    );
  }, [addSelectId, provinceLabel, cityLabel, countyLabel, streetLabel, addressInfo]);

  useEffect(() => {
    setProvinceLabel(provincialList?.find?.(ele => ele.value === province)?.label || '');
    setCityLabel(cityList?.find?.(ele => ele.value === city)?.label || '');
    setCountyLabel(countyList?.find?.(ele => ele.value === county)?.label || '');
    setStreetLabel(streetList?.find?.(ele => ele.value === street)?.label || '');
  }, [province, city, county, street, provincialList, cityList, countyList, streetList,]);

  return (
    <Form
      name="basic"
      labelCol={{ span: 4 }}
      initialValues={{ remember: true }}
      autoComplete="off"
      className={`address-cls ${required ? 'requi' : ''}`}
    >
      <LgInput
        title={(provinceLabel + cityLabel + countyLabel + streetLabel + addressInfo) || errAddress}
        value={(provinceLabel + cityLabel + countyLabel + streetLabel + addressInfo) || errAddress}
        disabled
        style={{ width: 570, height: 30, textOverflow: 'ellipsis' }}
      />
      <Form.Item label="所在地区">
        <div className="SelectAddress">
          <div className="select-group">
            <MySelect
              value={province}
              onChange={handleProvinceChange}
              options={provincialList}
              placeholder="请选择省份"
              width="120px"
            />
            <MySelect
              value={city}
              onChange={handleCityChange}
              options={cityList}
              placeholder="请选择城市"
              disabled={!province}
              width="120px"
            />
            <MySelect
              value={county}
              onChange={handleCountyChange}
              options={countyList}
              placeholder="请选择县区"
              disabled={!city}
              width="120px"
            />
            <MySelect
              value={street}
              onChange={handleStreetChange}
              options={streetList}
              placeholder="请选择街道"
              disabled={!county}
              width="120px"
            />
          </div>
        </div>
      </Form.Item>
      <Form.Item label="详细地址">
        <LgInput
          style={{ width: '400px', height: 30 }}
          placeholder="请输入详细信息"
          maxLength={20}
          value={addressInfo}
          onChange={(e: any) => setAddressInfo(e.target.value)}
          className="selfmsg"
        />
      </Form.Item>
    </Form>
  );
};

export default SelectAddress;
